import { reviewerInvite, minvitedReviewer } from '@/api/reviewer'
import help from '@/utils/help'
import zip from '@/utils/zip'
import { DECISION_STATUS } from '@/utils/dict'
import { mapGetters } from 'vuex'
import { getUploadConfig } from '@/utils/upload'
import customerReviewQuestion from '@/components/question.vue'
import reviewRating from './review-rating.vue'

const columns = [
  {
    title: '',
    enTitle: 'File Name',
    width: 230,
    dataIndex: 'name',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Size',
    width: 80,
    dataIndex: 'size',
    slot: 'size'
  },
  {
    title: '',
    enTitle: 'Description',
    width: 320,
    dataIndex: 'description',
    slot: 'description'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: { customerReviewQuestion, reviewRating },
  data() {
    return {
      showEditor: true,
      showAuthor: true,
      showFile: true,
      showVersion: true,
      showResponse: true,
      responseData: {},
      columns,
      decisionStatus: DECISION_STATUS,
      isEdit: false,
      editData: { authorReply: '' },
      loading: false,
      authorFile: [],
      activeKey: '',
      personInfo: {},
      fileVisible: false,
      ratingVisable: false,
      rate: {
        EXCELLENT: 'Excellent',
        GOOD: 'Good',
        AVERAGE: 'Average',
        POOR: 'Poor'
      },
      inputData: {}
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      title: 'getTitle',
      user: 'getUser',
      domain: 'getDomain',
      publisherId: 'getPublisherId'
    })
  },
  mounted() {
    this.getData()
  },
  methods: {
    download(item) {
      const file = item
      if (file) {
        const url = file.path
          ? this.domain + '/' + file.path
          : window.URL.createObjectURL(file.file)
        help.download(url, file.name)
      } else {
        zip.zipFile(item, 'author_files.zip')
      }
    },
    async getData() {
      const parmas = this.$route.params
      const querySign = this.$route.query
      let data = {
        sign: querySign.sign
      }
      let id = parmas.id
      const result = await minvitedReviewer.decisionHistory(id)
      // const result = res.result || []
      this.personInfo = result
      this.activeKey = this.activeKey
        ? this.activeKey
        : data.sign
        ? data.sign
        : result.decisionHistoryList[0]['sign']

      this.responseData = this.activeKey
        ? result.decisionHistoryList.filter(
            item => item.sign == this.activeKey
          )[0]
        : result.decisionHistoryList[0]
      this.editData.authorReply = this.responseData.authorReply
      this.authorFile = this.responseData.authorReplyFileList || []
    },
    checkVersion(value) {
      this.activeKey = value.sign
      this.responseData = value
      this.editData.authorReply = this.responseData.authorReply
      this.authorFile = this.responseData.authorReplyFileList || []
      this.isEdit = false
    },
    back() {
      this.$router.back(-1)
    },

    async report() {
      const parmas = this.$route.params
      let id = parmas.id
      let data = {
        id: this.responseData.id,
        sign: this.responseData.sign,
        manuscriptId: this.responseData.manuscriptId,
        version: this.responseData.version
      }

      const reportList = this.personInfo.decisionHistoryList
      if (reportList.length === 1) {
        if (!this.responseData.rating) {
          this.rating()
          return
        }
      } else if (reportList.length > 1) {
        const flag = reportList.find(item => {
          return item.rating
        })
        if (!flag) {
          if (!this.responseData.rating) {
            this.rating()
            return
          }
        }
      }

      await reviewerInvite.accept(data)
      this.$message.success({
        title: 'Success',
        content: 'Report successfully'
      })
      // this.$router.back(-1)
      this.getData()
    },

    cancelReport() {
      const parmas = this.$route.params
      let id = parmas.id

      let data = {
        id: id,
        version: this.responseData.version
      }
      this.$confirm({
        title: 'Cancel Review Report',
        content: 'Are you sure you want to cancel this review report？',
        type: 'warning',
        icon: 'iconDetails'
      }).then(async () => {
        await minvitedReviewer.cancel(data)
        this.$message.success({
          title: 'Success',
          content: 'Cancel Acceptance successfully!'
        })
        this.getData()
      })
    },
    editResponse() {
      this.isEdit = true
    },
    // 文件修改
    async handleUpload(files) {
      const types = [
        'pdf',
        'docx',
        'doc',
        'txt',
        'png',
        'jpg',
        'jpeg',
        'mp4',
        'mp3',
        'html',
        'xml',
        'mov',
        'xls',
        'xlsx',
        'zip',
        'tif',
        'tiff',
        'rtf'
      ]
      if (files.length === 1) {
        const file = files[0]
        let type = file.name.split('.')
        type = type[type.length - 1].toLowerCase()
        if (!types.includes(type)) {
          this.$message.error({
            title: 'Error',
            content: this.LANGUAGE[this.language].isWrongType
          })
          return false
        } else {
          this.addFile(file)
        }
      } else {
        files.forEach(file => {
          let type = file.name.split('.')
          type = type[type.length - 1].toLowerCase()
          if (types.includes(type)) {
            this.addFile(file)
          }
        })
      }
    },
    async addFile(file) {
      const path = `publisher/${this.publisherId}/manuscript/${
        this.responseData.manuscriptId
      }/submit/${help.guid()}`

      this.loading = true
      const url = await getUploadConfig(file, path)
      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }
      const flag = this.authorFile.some(val => {
        if (file.name === val.name) {
          val = {
            name: file.name,
            size: file.size,
            description: '',
            path: url,
            file: file,
            authorShowed: val.authorShowed ? val.authorShowed : true,
            sort: val.sort
          }
          return true
        }
      })
      if (!flag) {
        this.authorFile.push({
          name: file.name,
          size: file.size,
          path: url,
          file: file,
          authorShowed: true,
          sort: ''
        })
      }
      this.loading = false
      this.authorFile.forEach((item, index) => {
        item.sort = index
      })
    },
    reviewAuthor(item) {
      item.authorShowed == undefined
        ? (item.authorShowed = true)
        : (item.authorShowed = !item.authorShowed)
      this.authorFile = JSON.parse(JSON.stringify(this.authorFile))
    },
    del(index) {
      this.$confirm({
        title: 'Are you sure you want to delete this file?',
        content:
          'Please be aware of once this file is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        if (index || index === 0) {
          this.authorFile.splice(index, 1)
        } else {
          this.authorFile = []
        }
        this.$message.success({
          title: 'Success',
          content: 'This file has been deleted!'
        })
      })
    },
    cancel() {
      this.isEdit = false
      this.editData.authorReply = this.responseData.authorReply
      this.authorFile = this.responseData.authorReplyFileList
    },
    async save() {
      this.editData.authorReplyFileList = this.authorFile
      // const parmas = this.$route.params
      let id = this.responseData.id
      let data = Object.assign(this.editData, {
        id: id,
        sign: this.responseData.sign,
        manuscriptId: this.responseData.manuscriptId
      })
      // return
      await minvitedReviewer.authorReply(data)
      this.$message.success({
        title: 'Success',
        content: 'Report successfully'
      })
      this.isEdit = false
      this.getData()
      // this.$router.back(-1)
    },
    async fileToAcademic(val, type) {
      this.responseData[type] = !val
      let data = {
        version: this.responseData.version,
        fileVisible: this.responseData[type]
      }
      if (type === 'authorFileVisible') {
        await minvitedReviewer.authorFileVisable(this.responseData.id, data)
      } else {
        await minvitedReviewer.fileVisable(this.responseData.id, data)
      }
      this.getData()
    },
    rating() {
      this.ratingVisable = true
      this.inputData = Object.assign(this.responseData, {
        __journalId: this.personInfo.journalId,
        __reportLength: this.personInfo.decisionHistoryList.length
      })
    },
    cancelRating() {
      this.ratingVisable = false
      this.getData()
    },
    linkto() {
      this.$router.push(
        `/editorial-office/manuscripts/details/${this.responseData.manuscriptId}`
      )
    }
  }
}
